import React from "react";
import { MessageBar, MessageBarType } from "@fluentui/react";

const WarningComponent = ({ message, isMultiline, onDismiss }) => {
  return (
    <MessageBar
      messageBarType={MessageBarType.warning}
      isMultiline={isMultiline ? isMultiline : false}
      dismissButtonAriaLabel={onDismiss ? "Close" : undefined}
      onDismiss={onDismiss}
      className="my-1"
    >
      {message}
    </MessageBar>
  );
};

export default WarningComponent;
